import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type {
  APISimpleDropDownCampaignResponse,
  Action,
  Dispatch,
  ThunkAction
} from 'types';

const LOADING = 'adminSearchCampaigns/LOADING';
const LOADED = 'adminSearchCampaigns/LOADED';
const RESET = 'adminSearchCampaigns/RESET';

type State = {
  isLoading: boolean,
  list: Array<APISimpleDropDownCampaignResponse>
};

const initialState: State = {
  isLoading: false,
  list: []
};

function setLoadingStatus(status: boolean): Action {
  return {
    type: LOADING,
    payload: {
      status
    }
  };
}

export function resetSearchCampaigns(): Action {
  return {
    type: RESET
  };
}

function searchResultsLoaded(data: Array<APISimpleDropDownCampaignResponse>): Action {
  return {
    type: LOADED,
    payload: {
      data
    }
  };
}

export function searchCampaigns(brandId: number): ThunkAction {
  const url = API.END_POINTS.ADMIN.searchCampaigns(brandId);

  return async (dispatch: Dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      const response = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(searchResultsLoaded(response.data));
      dispatch(setLoadingStatus(false));
    } catch (error) {
      // 404 are fine here
      if (error?.response?.status !== 404) {
        logError(error);
      }
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };
}

export default createReducer<State, any>('adminSearchCampaigns', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [LOADED]: (state, { data }) => ({
    ...state,
    list: data
  })
});
